import { render, staticRenderFns } from "./IconHeadLightbulbOutline.vue?vue&type=template&id=c9d27e98&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports